import React from 'react'
import {
  Card, Button
} from 'semantic-ui-react'

import {getLanguageScope} from '../../../../helpers'
const _i18n = getLanguageScope('check_cashing');

import ImageUser from '../../../../assets/user_placeholder.png'

class CustomerCard extends React.Component {
  constructor(props){
    super(props);
  }

  resetCustomer = () => {
    const { resetCustomer, resetCheckUploading, resetCheckResult, resetScannerResult } = this.props;

    resetCustomer();
    resetCheckUploading();
    resetCheckResult();
    resetScannerResult();
  };

  renderExtra = () => {
    const { check_images_processing } = this.props;

    return (
      <a>
        <Button disabled={check_images_processing} onClick={this.resetCustomer} basic color='red'>
          {_i18n('change_customer')}
        </Button>
      </a>
    )
  };

  render(){
    const {customer_name, customer_phone, customer_address, customer_photo} = this.props;

    return (
      <Card
        style={{marginTop: 15}}
        image={customer_photo || ImageUser}
        header={customer_name}
        meta={customer_phone}
        description={customer_address}
        extra={this.renderExtra()}
      />
    )
  }
}

export default CustomerCard;




// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/components/CustomerCard.js